export interface DigitalSignatureModel {
  tokenUrl: string;
  error: string;
}

export interface SignerModel {
  name: string;
  institution: string;
}

export const AKD = 0;
export const FINA = 1;

export const ENTITY_TYPE = {
  CASE_ACT: 'case-act',
  CASE_ATTACHMENT: 'case-attachment',
  CASE_ACT_ATTACHMENT: 'case-act-attachment',
  PROJECT_DOCUMENT_ATTACHMENT: 'project-document-attachment',
  MAIN_PROJECT_DOCUMENT_ATTACHMENT: 'main-project-document-attachment',
};
